import {
  ResponseError,
  ResponseUserAuthData,
} from '@base/features/auth/model/interfaces';

export function isUserAuthData(
  data: ResponseError | ResponseUserAuthData
): data is ResponseUserAuthData {
  return (data as ResponseUserAuthData).code === 0;
}

export function isResponseError(
  data: ResponseError | any
): data is ResponseError {
  return (data as ResponseError).code !== 0;
}
